<template>
  <div>
    <PredictionList v-if="showPredictionList" @raceSelected="raceSelected($event)"/>
    <RaceDetail v-if="showRaceDetail" :raceId="raceId" :race="race"/>
  </div>
</template>

<script>
import PredictionList from './PredictionList';
import RaceDetail from './RaceDetail'

export default {
  name: 'PredictionPage',
  components: {
    PredictionList,RaceDetail
  },
  props: {
  },
  data () {
    return {
      title: 'PredictionPage',
      showPredictionList: true,
      showRaceDetail: false,
      race: {},
    }
  },
  watch: {
    $route(to, from) {
      this.loadPageByRoute()
    }
  },
  methods: {
    raceSelected: function(race) {
      this.race = race
    },
    loadPageByRoute: function () {
      if (this.$route.params.raceId) {
        this.showRaceDetail = true
        this.showPredictionList = false
        this.raceId = this.$route.raceId
      }else {
        this.showRaceDetail = false
        this.showPredictionList = true
      }
    }
  },
  mounted () {
    this.loadPageByRoute()
  }
}

</script>
